/** Blank LTL line row for UI and normalized draft when no persisted lines exist. */
export const EMPTY_NORMALIZED_LTL_DRAFT_ITEM = {
  class: "",
  isHazardous: false,
  pieces: "",
  piecesCount: 1,
  weight: 0,
  packaging: "",
  packagingCount: 1,
} as const;
